import { createContext, useContext } from "react";

const Name = createContext();
const useName = () => useContext(Name);
export function Lol() {
  return (
    <div className='grid justify-center p-4 h-[calc(100vh-88px)]'>
      <img
        className=' h-full rounded-xl'
        src='https://c.tenor.com/WmIEqvGZKxsAAAAC/lol.gif'
        alt=''
      />
    </div>
  );
}
